

export const Numeric = ({ idx, page }) => { return ((parseInt(page) * 15) - 15) + parseInt(idx) + 1 }